export default __webpack_public_path__ + "src/docs/packages/palms-on-the-rocks.pdf";